import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import RubberNavigation from './Component/RubberNavigation';

const theme = createTheme ({
  typography: {
    fontFamily: [
      'yugothic', 
      '游ゴシック体', 
      'Yu Gothic', 
      'YuGothic',
      'Meiryo',
      'メイリオ',
      'MS PGothic',
      'MS Pゴシック', 
      'sans-serif',
    ].join(','),
    fontWeightRegular: '500',
  },
  palette: {
    secondary: {
      main: '#E28C0A',
      contrastText: '#ffffff',
    },
  }
});

const Base = () => {
    return (
        <Box>
            <RubberNavigation />
        </Box>
    );
}

export default function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <div>
        <CssBaseline />
        <BrowserRouter>
          <div>
            <Routes>
              <Route path="/" exact element={ <Base/> } />
            </Routes>
          </div>
        </BrowserRouter>
      </div>
    </MuiThemeProvider>
  );
};